import { render, staticRenderFns } from "./PEC_lunBo1.vue?vue&type=template&id=96d59f50"
import script from "./PEC_lunBo1.vue?vue&type=script&lang=js"
export * from "./PEC_lunBo1.vue?vue&type=script&lang=js"
import style0 from "./PEC_lunBo1.vue?vue&type=style&index=0&id=96d59f50&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports